import {
  Button,
  Flex,
  Icon,
  Text,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useColorMode,
  useColorStyle,
  Space,
} from '@tonic-one/react';
import { InfoIcon } from '@tonic-one/react-icons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PolicySubTypeEnum } from '../../../../types';
import { GmailInlinePolicyEvent } from '../../utils/constants';

const SwitchTargetTypeModal = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation('policy');
  const [isOpen, setIsOpen] = useState(false);
  const [detail, setDetail] = useState<{
    type: PolicySubTypeEnum;
    callback: () => void;
  } | null>(null);

  useEffect(() => {
    const callback = (e: any) => {
      setIsOpen(true);
      setDetail(e.detail);
    };
    window.addEventListener(GmailInlinePolicyEvent.SwitchTargetType, callback);

    return () => {
      setIsOpen(false);
      window.removeEventListener(
        GmailInlinePolicyEvent.SwitchTargetType,
        callback
      );
    };
  }, []);

  if (!detail) {
    return <></>;
  }

  const desc = t(
    `policy.modals.gmailEnable.changeTargetType.${
      detail.type === PolicySubTypeEnum.inbound ? 'inbound' : 'outbound'
    }`
  );
  return (
    <Modal isOpen={isOpen} size="md" onClose={() => setIsOpen(false)}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('policy.modals.gmailEnable.title')}</ModalHeader>
        <ModalBody>
          <Flex alignItems="top" gap="8px">
            <Icon as={InfoIcon} color={colorStyle.color.info} />
            <Text>{t('policy.modals.gmailEnable.note')}</Text>
          </Flex>
          <Space height="20px" />
          <Text
            dangerouslySetInnerHTML={{
              __html: desc,
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            onClick={() => {
              detail.callback();
              setIsOpen(false);
            }}
          >
            {t('common.button.ok')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const SelectAllUserTargetModal = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation('policy');
  const [isOpen, setIsOpen] = useState(false);
  const [detail, setDetail] = useState<{
    callback: () => void;
  } | null>(null);
  useEffect(() => {
    const callback = (e: any) => {
      setIsOpen(true);
      setDetail(e.detail);
    };
    window.addEventListener(
      GmailInlinePolicyEvent.SelectAllUserTarget,
      callback
    );
    return () => {
      setIsOpen(false);
      window.removeEventListener(
        GmailInlinePolicyEvent.SelectAllUserTarget,
        callback
      );
    };
  }, []);

  return (
    <Modal isOpen={isOpen} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('policy.modals.gmailEnable.title')}</ModalHeader>
        <ModalBody>
          <Flex alignItems="top" gap="8px">
            <Icon as={InfoIcon} color={colorStyle.color.info} />
            <Text>{t('policy.modals.gmailEnable.note')}</Text>
          </Flex>
          <Space height="20px" />
          <Text>{t('policy.modals.gmailEnable.selectAllUser.desc')}</Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            onClick={() => {
              detail?.callback();
              setIsOpen(false);
            }}
          >
            {t('common.button.ok')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export const GmailInlinePolicyModal = () => {
  return (
    <>
      <SwitchTargetTypeModal />
      <SelectAllUserTargetModal />
    </>
  );
};
